/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Content_QuestionInputs */

const en_onboarding_content_question = /** @type {(inputs: Onboarding_Content_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What type of content do you spend the most time with?`)
};

const es_onboarding_content_question = /** @type {(inputs: Onboarding_Content_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Con qué tipo de contenido pasas más tiempo?`)
};

/**
* | output |
* | --- |
* | "What type of content do you spend the most time with?" |
*
* @param {Onboarding_Content_QuestionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_content_question = /** @type {((inputs?: Onboarding_Content_QuestionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Content_QuestionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_content_question(inputs)
	return en_onboarding_content_question(inputs)
});